(function ($) {
    $(document).ready(function () {
        if ((".banner-with-info").length > 0) {
            var len = $('.banner-with-info .text-wrap p').length;
            if (len > 1) {
                $('.banner-with-info .text-wrap p', this).eq(0).nextAll().hide().addClass('toggleable');
                $('.banner-with-info p.toggleable').prev().addClass('ellipsis');
            }
            if (len < 2) {
                $('.banner-with-info .btn-wrap span').hide();
            }
            $('.banner-with-info .btn-wrap span').on('click', function () {
                $('.banner-with-info .text-wrap').find('p.toggleable').slideToggle(function () {
                    if ($(this).is(':visible')) {
                        $('.banner-with-info .btn-wrap span').text("Read Less");
                        $('.banner-with-info .toggleable').prev().removeClass('ellipsis');

                    }
                    else {
                        $('.banner-with-info .btn-wrap span').text("Read More");
                        $('.banner-with-info .toggleable').prev().addClass('ellipsis');

                    }
                });

            });
        }
    });
})(jQuery);